import { SearchQuery, isSearchQueryArray } from 'modules/domains';

import { useRootQueryState } from '../useRootQueryState';

export const useCriteriaArray = (): SearchQuery[] => {
  const [rootQuery] = useRootQueryState();
  return isSearchQueryArray(rootQuery.searchQueries) ? rootQuery.searchQueries : [];
};
